// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__Y9v1r","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3tN-E","obliqueLine":"membershipbadge_obliqueLine__3kagQ"};